import { useI18n } from 'vue-i18n';
import { createFetcher } from '@composables/createFetcher';

export type ContentGetPayload = {
  id?: string;
  collectionId?: string;
};

export type ContentPlayPayload = {
  contentId: string;
  thumbnailTime?: number;
};

export const useContentFetcher = () => {
  const { t } = useI18n();

  const oneFetcher = createFetcher<ContentGetPayload>({
    endpoint: '/content',
    method: 'GET',
    requiresAuth: true,
    requiresArtistId: true,
    payloadAsQuery: true,
    validatePayload: (payload) => {
      if (!payload.id) {
        oneFetcher.error.value = t('errors.couldNotLoadContent');
        return false;
      }
      return true;
    },
  });

  const listFetcher = createFetcher<ContentGetPayload>({
    endpoint: '/content',
    method: 'GET',
    requiresAuth: true,
    requiresArtistId: true,
    payloadAsQuery: true,
  });

  return {
    one: {
      ...oneFetcher,
      resetOne: () => {
        oneFetcher.data.value = null;
        oneFetcher.error.value = null;
      },
    },
    list: {
      ...listFetcher,
      resetList: () => {
        listFetcher.data.value = null;
        listFetcher.error.value = null;
      },
    },
  };
};

export const useContentPlayFetcher = () => {
  return createFetcher<ContentPlayPayload>({
    endpoint: '/content/play',
    method: 'GET',
    requiresAuth: true,
    requiresArtistId: true,
    payloadAsQuery: true,
    validatePayload: (payload) => !!payload.contentId,
  });
};
